// extracted by mini-css-extract-plugin
export var container = "_42-0";
export var error = "_42-9";
export var label = "_42-5";
export var light = "_42-6";
export var md = "_42-3";
export var sm = "_42-2";
export var thin = "_42-8";
export var thinBold = "_42-7";
export var vertical = "_42-4";
export var xs = "_42-1";